// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/self-service-item/self-service-item.component.scss
// module id = 496
// module chunks = 0